import { combineReducers } from "redux";
import { CREATE_CLINIC_REQUEST, FETCH_CLINICS_REQUEST } from "./constants";
import {
  CHANGE_CLINIC_STATUS_REQUEST,
  UPDATE_CLINIC_REQUEST,
  UPDATE_WEIGHT_REQUEST,
} from "../clinic/constants";
import { getFailureActionType, getSuccessActionType } from "../utils";
import { Action } from "./types";
import { Action as ClinicAction } from "../clinic/types";
import { Clinic } from "../types";

function items(state: Clinic[] = [], action: Action | ClinicAction): Clinic[] {
  switch (action.type) {
    case getSuccessActionType(FETCH_CLINICS_REQUEST):
      return action.payload;

    case UPDATE_CLINIC_REQUEST:
    case CHANGE_CLINIC_STATUS_REQUEST:
    case UPDATE_WEIGHT_REQUEST:
      return state.map((clinic) =>
        clinic.id === action.data.clinicId ? { ...clinic, isFetching: true } : clinic
      );

    case getSuccessActionType(UPDATE_CLINIC_REQUEST):
    case getSuccessActionType(CHANGE_CLINIC_STATUS_REQUEST):
    case getSuccessActionType(UPDATE_WEIGHT_REQUEST):
      return state.map((clinic) =>
        clinic.id === action.data.clinicId ? { ...action.payload, isFetching: false } : clinic
      );

    case getFailureActionType(UPDATE_CLINIC_REQUEST):
    case getFailureActionType(CHANGE_CLINIC_STATUS_REQUEST):
    case getFailureActionType(UPDATE_WEIGHT_REQUEST):
      return state.map((clinic) =>
        clinic.id === action.data.clinicId ? { ...clinic, isFetching: false } : clinic
      );

    case getSuccessActionType(CREATE_CLINIC_REQUEST):
      return [...state, action.payload];

    default:
      return state;
  }
}

function isFetching(state: boolean = false, action: Action): boolean {
  switch (action.type) {
    case FETCH_CLINICS_REQUEST:
      return true;
    case getSuccessActionType(FETCH_CLINICS_REQUEST):
    case getFailureActionType(FETCH_CLINICS_REQUEST):
      return false;

    case CREATE_CLINIC_REQUEST:
      return true;
    case getSuccessActionType(CREATE_CLINIC_REQUEST):
    case getFailureActionType(CREATE_CLINIC_REQUEST):
      return false;
    default:
      return state;
  }
}

export const clinics = combineReducers({ items, isFetching });
